import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../js/appConstants.js";
import "../css/home.css";

const offerings = [
  { title: "Regular Bhajans", text: "A welcoming space for weekly bhajans, Ekadasi observances and Kaarthika Pournami gatherings." },
  { title: "Sacred Celebrations", text: "Radha, Seetha and Meenakshi Kalyanams celebrated through music, devotion and shared tradition." },
  { title: "Music & Learning", text: "Explore abhangas, Oothukadu kritis, pavvalippu, dolothsavam and recordings from the samajam." }
];

class Home extends Component {
  constructor(props) {
    super(props);
    window.clickLog("load", "homepage");
  }

  render() {
    return (
      <div className="home-page">
        <section className="hero" aria-labelledby="home-title">
          <div className="hero__content">
            <p className="eyebrow">Since 1983 · Chennai</p>
            <h1 id="home-title">A living home for <span>bhajans and sathsangam.</span></h1>
            <p className="hero__lead">RadhaKrishna Sankeerthana Samajam brings devotees together through the enduring joy of nama sankeerthanam, music and fellowship.</p>
            <div className="hero__actions">
              <Link to="/ProgramAndEvents" className="button button--primary">Explore programs</Link>
              <Link to="/Downloads" className="button button--secondary">Listen to music</Link>
            </div>
          </div>
          <div className="hero__image-wrap"><img className="hero__image" src="/images/radha-krishna.jpg" alt="Radha and Krishna" /></div>
        </section>
        <section className="home-section" aria-labelledby="offerings-title">
          <h2 id="offerings-title">Gather, sing, and celebrate</h2>
          <p className="home-section__intro">From intimate weekly bhajans to landmark celebrations, our samajam keeps a cherished devotional tradition vibrant for every generation.</p>
          <div className="practice-grid">
            {offerings.map((offering, index) => (
              <article className="practice-card" key={offering.title}>
                <span className="practice-card__number">0{index + 1}</span><h3>{offering.title}</h3><p>{offering.text}</p>
              </article>
            ))}
          </div>
        </section>
        <section className="heritage" aria-label="Our heritage"><p>Founded in 1983 at the home of Shri Papanasam Ramani Bhagavathar in Pozhichalur, the samajam was named <em>Shri Sankara Hall</em> by the blessings of the Kanchi Acharyas.</p></section>
        <section className="home-section"><h2>Join the sathsangam</h2><p className="home-section__intro">For upcoming gatherings, ways to connect, and sathsangam details, please visit our <Link to="/ContactUs">contact page</Link>.</p><p className="home-section__intro home-closing">Radhe Krishna! Sai Ram!</p></section>
      </div>
    );
  }
}

export default Home;
